import React, { useEffect, useRef } from 'react';
import StyledButton from 'components/Button';
import { CancelModalContainer } from './style';
import { CrossIcon } from 'assets/icons';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import {
  cancelBookingModalOpenState,
  cancelReasonModalOpenState,
  cancelGroupId,
  cancelBookingId,
} from 'states/ModalStates/atoms';
import { useCancellationPreview } from 'customHooks/useCancellationPreview';

const CancelBookingModalBody: React.FC = () => {
  const debug = false;

  const setOpenCancelBookingModal = useSetRecoilState(cancelBookingModalOpenState);
  const setOpenCancelReasonModal = useSetRecoilState(cancelReasonModalOpenState);
  const groupId = useRecoilValue(cancelGroupId);
  const bookingId = useRecoilValue(cancelBookingId);

  const isGroupCancel = groupId.length > 0;

  const {
    getCancellationPreview,
    message,
    cancellationFeeAmount,
    cancellationPreview,
    loading,
  } = useCancellationPreview();

  const hasRequested = useRef(false);

  useEffect(() => {
    if (hasRequested.current) return;

    if (isGroupCancel && groupId) {
      hasRequested.current = true;
      getCancellationPreview({ groupId });
      return;
    }

    if (!isGroupCancel && bookingId) {
      hasRequested.current = true;
      getCancellationPreview({ bookingId });
    }
  }, [isGroupCancel, groupId, bookingId, getCancellationPreview]);

  if (debug) {
    console.log('Cancel groupId = ', groupId);
    console.log('Cancel bookingId = ', bookingId);
    console.log('cancellationPreview = ', cancellationPreview);
  }

  // 👉 Не показываем модалку, пока нет данных
  if (loading || !cancellationPreview) {
    return null;
  }

  const handleCancelBooking = () => {
    setOpenCancelBookingModal(false);
    setOpenCancelReasonModal(true);
  };

  return (
    <CancelModalContainer>
      <div
        className="closeButton"
        onClick={() => {
          setOpenCancelBookingModal(false);
        }}
      >
        <CrossIcon />
      </div>

      <div className="cardTitle">
        {isGroupCancel ? 'Cancel your booking' : 'Remove room from booking'}
      </div>

      <div className="contentTitle">
        {isGroupCancel
          ? 'Are you sure you want to cancel this booking?'
          : 'Are you sure you want to remove this room from your booking?'}
      </div>

      <div className="description">
        {message ||
          `Cancellation policy is not available right now. If you cancel, there may be a fee of $${cancellationFeeAmount}.`}
      </div>

      <div className="buttonContainer">
        <div className="link" onClick={handleCancelBooking}>
          {isGroupCancel ? 'Cancel Booking' : 'Remove Room'}
        </div>

        <StyledButton
          width="142px"
          height="48px"
          onClick={() => setOpenCancelBookingModal(false)}
        >
          Keep {isGroupCancel ? 'Booking' : 'Room'}
        </StyledButton>
      </div>
    </CancelModalContainer>
  );
};

export default CancelBookingModalBody;